<template>
  <div id="home-login">
    <div class="login">
      <el-row :gutter="75">
        <el-col :span="12">
          <div class="item">
            <h3>康保通员工健康福利会员卡</h3>
            <p @click="handleLogInClick1">点击登录 <span class="iconfont">&#xe641;</span></p>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="item">
            <h3>康保通健康联名卡</h3>
            <p @click="handleLogInClick2">点击登录 <span class="iconfont">&#xe641;</span></p>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeLogin",
  components: {},
  data() {
    return {
      name1: "康保通员工健康福利会员卡",
      name2: "康保通健康联名卡"
    };
  },
  mounted() {},
  methods: {
    handleLogInClick1() {
      this.$router.push({
        path: "StaffLogin",
      });
    },
    handleLogInClick2() {
      this.$router.push({
        path: "KangLogin",
      });
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
#home-login {
  width: 75%;
  margin: 0 auto;
  overflow: hidden;
  padding: 15px;
  .login {
    margin-top: 73px;
    margin-bottom: 64px;
    .item {
      height: 128px;
      box-shadow: 0 5px 18px 3px rgba(165, 210, 255, 0.19);
      text-align: center;
      overflow: hidden;
      h3 {
        margin-top: 34px;
        color: #5b5b5b;
        font-size: 24px;
      }
      p {
        margin-top: 30px;
        font-size: 20px;
        color: #388cdf;
        font-weight: 500;
        cursor: pointer;
        .iconfont {
          font-size: 20px;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
